import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { IDLE_TIMEOUT } from "utils/CommonConstants";
import { userLogout } from "utils/CommonFunctions";

export default function SessionTimeout() {
  const [events] = useState(["click", "load", "scroll"]);
  const [isOpen, setOpen] = useState(false);
  const POP_TIME: number = 1;
  const TIME_CHECKER: number = 60000;
  let timeStamp: any;
  let warningInactiveInterval: any = useRef();
  let startTimerInterval: any = useRef();

  let timeChecker = () => {
    startTimerInterval.current = setTimeout(() => {
      let storedTimeStamp: any = sessionStorage.getItem("lastTimeStamp");
      warningInactive(storedTimeStamp);
    }, TIME_CHECKER);
  };

  // warning timer
  let warningInactive = (timeString: string) => {
    clearTimeout(startTimerInterval.current);

    warningInactiveInterval.current = setInterval(() => {
      const maxTime: any = IDLE_TIMEOUT;
      const popTime = POP_TIME;

      const diff = moment.duration(moment().diff(moment(timeString)));

      const minPast = diff.minutes();

      if (minPast === popTime) {
        setOpen(true);
      }

      if (minPast === maxTime) {
        clearInterval(warningInactiveInterval.current);
        setOpen(false);
        sessionStorage.removeItem("lastTimeStamp");
        // logout functionality
        alert("You've been logged out!");
        userLogout();
      }
    }, 1000);
  };

  // reset interval timer
  let resetTimer = useCallback(() => {
    clearTimeout(startTimerInterval.current);
    clearInterval(warningInactiveInterval.current);
    timeStamp = moment();
    sessionStorage.setItem("lastTimeStamp", timeStamp);
    timeChecker();
    setOpen(false);
  }, [true]);

  useEffect(() => {
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    return () => {
      clearTimeout(startTimerInterval.current);
    };
  }, [resetTimer, events, timeChecker]);

  if (!isOpen) {
    return null;
  }
  return <></>;
}
